/**
 * Logs a message
 * 
 * This function logs a message with a timestamp to the console in development mode
 * and sends the message to the server for logging to a file. It supports different
 * log types: notice, warning, and error.
 * 
 * @param {string} message - The message to log.
 * @param {'notice' | 'warning' | 'error'} type - The type of log message.
 * 
 * @returns {Promise<void>} A promise that resolves when the logging is complete.
 */
export const logMessage = async (
  message: string,
  type: 'notice' | 'warning' | 'error' = 'error'
): Promise<void> => {
  const timestamp = new Date().toISOString();
  const logMessage = `[${timestamp}] ${type.toUpperCase()}: ${message}\n`;

  // Log to the console if not in production
  if (process.env.NODE_ENV !== 'production') {
    console[type === 'error' ? 'error' : 'log'](logMessage);
  }

  /*
  try {
    const response = await fetch('/api/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ message, type }),
    });

    if (!response.ok) {
      console.error('Failed to log message');
    }
  } catch (err) {
    console.error('An error occurred while logging the message:', err);
  }
  */
};
